import { normalizeResolvedPath } from '../../../paths/normalize-resolved-path.js';
import { addPendingSymbolIndexTask, latestActiveSequenceByParent, pendingSymbolIndexTasks, symbolIndexTaskHeap } from './task-queue-store.js';

/** Background warmup and neighbor prefetch sit below interactive code-nav work. */
export const SYMBOL_INDEX_BACKGROUND_PRIORITY_MAX = 499_999;

export function enqueueSymbolIndexTaskInternal(
  parentPath: string,
  filePath: string,
  priority: number,
  sequence?: number,
): boolean {
  const normalizedParent = normalizeResolvedPath(parentPath);
  const normalizedFile = filePath.replace(/\\/g, '/').replace(/^\/+/, '');
  if (!normalizedFile) return false;

  return addPendingSymbolIndexTask({
    parentPath: normalizedParent,
    filePath: normalizedFile,
    priority,
    sequence,
  });
}

export function markLatestActiveSymbolIndexTaskInternal(parentPath: string, sequence: number): void {
  const normalizedParent = normalizeResolvedPath(parentPath);
  const existing = latestActiveSequenceByParent.get(normalizedParent);
  if (existing != null && existing >= sequence) return;
  latestActiveSequenceByParent.set(normalizedParent, sequence);

  for (const [key, task] of pendingSymbolIndexTasks) {
    if (task.parentPath === normalizedParent && task.sequence != null && task.sequence < sequence) {
      pendingSymbolIndexTasks.delete(key);
    }
  }
  if (pendingSymbolIndexTasks.size === 0) symbolIndexTaskHeap.clear();
}

/** Drop low-priority queued work when the user starts browsing files. */
export function deferBackgroundSymbolIndexTasks(): void {
  if (pendingSymbolIndexTasks.size === 0) return;

  for (const [key, task] of pendingSymbolIndexTasks) {
    if (task.priority <= SYMBOL_INDEX_BACKGROUND_PRIORITY_MAX) {
      pendingSymbolIndexTasks.delete(key);
    }
  }

  symbolIndexTaskHeap.clear();
  for (const task of pendingSymbolIndexTasks.values()) {
    symbolIndexTaskHeap.push(task);
  }
}

export { deferBackgroundSymbolIndexTasks as deferBackgroundSymbolIndexTasksForTests };
